import './style/index.js';

import _Image from './image';

export type { ImageProps } from './image';

export const Image = _Image;

export default Image;
